'use client';

import * as React from 'react';
/**
 * @ignore - internal component.
 */
export const AccountLocaleContext = /*#__PURE__*/React.createContext(null);